export default function addChecklist (state, checklist) {
  state.checklists = [...state.checklists, checklist]
}
